import React, { useContext } from 'react';
import { StateContext } from "../../state/index";
import { FLOW_TYPES } from "../../utils/enums";
import { InitializePaywallFlow } from './flows/index';
import { BaseView } from './views/index';
import { get } from 'lodash/object';

export const ValidatePaymentFlow = () => {
  const [applicationState] = useContext(StateContext);

  let View = BaseView;
  let Flow;
  const flowType = get(applicationState, 'configuration.validatePayment.flow');
  switch(flowType){
    case FLOW_TYPES.VALIDATE_PAYMENT.URL_VALIDATION:
    default:
      Flow = InitializePaywallFlow;
      break;
  }

  return <Flow><View/></Flow>
};

export default ValidatePaymentFlow;
